import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'
import { splitWords } from '@/lib/gsap'

interface SplitLettersProps {
    text: string
}

// Renders copy as per-letter spans (marked data-letter) for the draft's
// brightening effects. Screen readers get the plain sentence instead.
const SplitLetters: FC<SplitLettersProps> = ({ text }): ReactNode => {
    const words = splitWords(text)

    return (
        <>
            <span className='sr-only'>{text}</span>

            <span aria-hidden='true'>
                {words.map((letters, wordIndex) => (
                    <Fragment key={`${wordIndex}-${letters.join('')}`}>
                        <span className='inline-block whitespace-nowrap'>
                            {letters.map((letter, letterIndex) => (
                                <span key={letterIndex} data-letter>{letter}</span>
                            ))}
                        </span>

                        {wordIndex < words.length - 1 && ' '}
                    </Fragment>
                ))}
            </span>
        </>
    )
}

export default SplitLetters
